import React, { Component } from 'react';
import classnames from 'classnames';
import {Col, Row} from 'react-bootstrap';
import Redux from 'redux';
import _ from 'underscore';
import ImageOrLettersView from './ImageOrLettersView';
import moment from 'moment';
import twitterText from 'twitter-text';

class MessageThreadItemView extends Component {

    getTime(time) {
        time = moment(time);
        return time.format('HH:mm');
    }

    createMarkup() {
        let text = this.props.message && this.props.message.text && this.props.message.text.toString() || '';
        const safeHtml = twitterText.autoLinkUrlsCustom(twitterText.htmlEscape(text), {urlTarget: '_top'});
        return {__html: safeHtml};
    }


    createThreadMessage(message) {
        if (!message) {
            return <div></div>;
        }
        if (message.sourceId === this.props.me.id) {
            return <div
                className="inbox-message-thread-item out padding-vertical-small margin-vertical-small text-left">
                <div dangerouslySetInnerHTML={this.createMarkup()}/>
                <span
                    className="inbox-message-thread-item-time">{this.getTime(this.props.message.created)}</span>
            </div>;
        } else {
            return <div className="inbox-message-thread-item-wrapper">
                <ImageOrLettersView image={this.props.person.photoUrl}
                    firstName={this.props.person.firstName}
                    lastName={this.props.person.lastName}
                    shape="round-corners"/>

                <div
                    className="inbox-message-thread-item in padding-vertical-small margin-vertical-small text-left color-1-background-opacity">
                    <div dangerouslySetInnerHTML={this.createMarkup()}></div>
                    <span
                        className="inbox-message-thread-item-time">{this.getTime(this.props.message.created)}</span>
                </div>
                <span className="inbox-message-thread-item-arrow">
                    <span className="inbox-message-thread-item-arrow-tip color-1-background-opacity"/>
                </span>
            </div>;
        }
    }

    render() {
        let cx = classnames;
        return <div className={cx('', {'text-right': this.props.message.sourceId === this.props.me.id})}>
            {this.createThreadMessage(this.props.message)}
        </div>;
    }
}

export default MessageThreadItemView;
